import { ConfigurationService } from "./../../configurationService";
import { AppMainComponent } from "./../../../app.main.component";
import { AppMainService } from "./../../../app-main.service";
import { MessageService, ConfirmationService } from "primeng/api";
import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-inventory-quantity",
    templateUrl: "./quantity.component.html",
    styleUrls: ["./quantity.component.scss"],
})
export class InventoryQuantityComponent implements OnInit {
    //inventory

    configMenuQuantityItems;
    allQty = [];
    selectedQty;
    allMathSymbol = [
        { id: 1, name: "+" },
        { id: 2, name: "-" },
    ];
    selectedMathSymbol;
    calculations = [];

    expandedRowsQty: {} = {};
    displayAddQty = false;
    displayAddQtyItem = false;
    addEditQtyHeader;
    addEditQtyItemHeader;
    tempQty = {
        id: 0,
        name: "",
        abbrevation: "",
        definition: "",
        description: "",
        typeId: 0,
        type: {
            id: 0,
            name: "",
        },
        isActive: true,
    };
    tempQtyItem = {
        id: 0,
        name: "",
        abbrevation: "",
        definition: "",
        description: "",
        typeId: 0,
        type: {
            id: 0,
            name: "",
        },
        groupId: 0,
        group: {
            id: 0,
            name: "",
        },
        isActive: true,
        children: [],
    };
    qtyTypes = [
        { id: 1, name: "To Location" },
        { id: 2, name: "In Location" },
        { id: 3, name: "From Location" },
    ];
    selectedQtyType;

    constructor(
        private service: ConfigurationService,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        public datepipe: DatePipe
    ) {}

    ngOnInit(): void {
        //inventory
        this.configMenuQuantityItems = [
            {
                label: "Qty",
                icon: "pi pi-plus",
                command: () => {
                    this.showAddQty();
                },
            },
            {
                label: "Qty Item",
                icon: "pi pi-plus",
                command: () => {
                    this.showAddQtyItem();
                },
            },
        ];

        this.appMainService.isShowSpinner('loadqty');
        this.service.getAllQtys().then((c) => {
            this.appMainService.isHideSpinner('loadqty');
            this.allQty = c;
        });
    }

    //inventory
    showAddQty() {
        this.addEditQtyHeader = "Add Qty";
        this.displayAddQty = true;
        this.tempQty = {
            id: 0,
            name: "",
            abbrevation: "",
            definition: "",
            description: "",
            typeId: 0,
            type: {
                id: 0,
                name: "",
            },
            isActive: true,
        };
    }
    showEditQty(c) {
        this.addEditQtyHeader = "Edit Qty";
        this.displayAddQty = true;
        this.selectedQtyType = c.type;
        this.tempQty = JSON.parse(JSON.stringify(c));
    }
    saveQty(c) {
        c.typeId = this.selectedQtyType.id;
        c.type = this.selectedQtyType;
        if (this.addEditQtyHeader == "Add Qty") {
            this.service.addQty(c).then((stages) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Added Successfully...",
                });
                this.service.getAllQtys().then((c) => {
                    this.allQty = c;
                });
                this.displayAddQty = false;
            });
        } else if (this.addEditQtyHeader == "Edit Qty") {
            this.service.EditQty(c).then((stages) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Updated Successfully...",
                });
                this.service.getAllQtys().then((c) => {
                    this.allQty = c;
                });
                this.displayAddQty = false;
            });
        }
    }
    delQty(c) {
        this.confirmationService.confirm({
            message: "Do you want to delete this Qty Type?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.service
                    .deleteQty(c.id)
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted Successfully...",
                        });
                        this.service.getAllQtys().then((c) => {
                            this.allQty = c;
                        });
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while deleting data...",
                        });
                    });
            },
            reject: () => {},
        });
    }
    showAddQtyItem() {
        this.addEditQtyItemHeader = "Add Qty Item";
        this.displayAddQtyItem = true;
        this.tempQtyItem = {
            id: 0,
            name: "",
            abbrevation: "",
            definition: "",
            description: "",
            typeId: 0,
            type: {
                id: 0,
                name: "",
            },
            groupId: 0,
            group: {
                id: 0,
                name: "",
            },
            isActive: true,
            children: [],
        };
    }
    showEditQtyItem(c, s) {
        this.addEditQtyItemHeader = "Edit Qty Item";
        this.displayAddQtyItem = true;
        this.tempQty = JSON.parse(JSON.stringify(c));
        this.tempQtyItem = JSON.parse(JSON.stringify(s));
    }
    addCalculation() {
        this.calculations.push(this.calculations.length);
    }
    removeCalculation(i) {
        this.calculations.splice(i, 1);
    }
    saveQtyItem(c, s) {
        if (s.definition == "") {
            s.definition = "-";
        }
        let arr = [];
        for (let item of c.children) {
            if (item.id == s.id) {
                item = JSON.parse(JSON.stringify(s));
                arr.push(item);
            } else {
                arr.push(item);
            }
        }
        c.children = JSON.parse(JSON.stringify(arr));

        this.service.EditQty(c).then((stages) => {
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Updated Successfully...",
            });
            this.service.getAllQtys().then((c) => {
                this.allQty = c;
            });
            this.displayAddQtyItem = false;
        });
    }
}
